// 服务器
// const BASEURL = 'http://192.168.1.51:58086'  //jyl本地
// const BASEURL = 'http://223.76.138.108:58080/prod-api' //打包换这个武汉本地部署
const BASEURL = 'https://tclhh.whst.org.cn/prod-api' //打包换这个武汉本地部署

// const BASEURL = 'https://hns-whg.cn/api' // 正式环境
const APP_PATH = 'https://hns-whg.cn/' //正式环境

const IMAGEPATH = 'https://cdn.hns-whg.cn/'
// const IMAGEPATH = 'http://192.168.3.200/api/'

const FILES = IMAGEPATH

export {
  BASEURL,
  IMAGEPATH,
  FILES,
  APP_PATH
}
